import { maxLengthValidator } from './max-length.validator';
import { minLengthValidator } from './min-length.validator';
import { getCardCvcLengthRangeByBrand } from '../card';
export const cardCvcLengthValidator = (cardBrand) => {
    var _a, _b;
    const cvcLengthRange = getCardCvcLengthRangeByBrand(cardBrand);
    const cvcMinLengthValidator = minLengthValidator((_a = cvcLengthRange.min) !== null && _a !== void 0 ? _a : Number.MIN_SAFE_INTEGER);
    const cvcMaxLengthValidator = maxLengthValidator((_b = cvcLengthRange.max) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER);
    return (value) => {
        return Object.assign(Object.assign({}, cvcMinLengthValidator(value)), cvcMaxLengthValidator(value));
    };
};
//# sourceMappingURL=card-cvc-length.validator.js.map